module.exports = __webpack_public_path__ + "media/images/bf-online-logo-en-aa697165948e50fcfc6c84b826c3b7df.svg";